import React, { useState } from 'react';
import { BettingSites } from "../data";
import {
    BetWayLogo,
    MarcaLogo,
    Bet365Logo,
    PastonLogo,
    BwinLogo,
    WilliamHillLogo,
    CodereLogo,
    LuckiaLogo,
    SportiumLogo,
    BetfairLogo,
    ApuestasLogo,
    OnexbetLogo,
    LeoVegasLogo,
    BotemaniaLogo,
    NoLogo
} from "./Logos";
 
import './componentsStyle/OpinionesWidget.css';

const validLogos = {
    "Betway": BetWayLogo,
    "Marca": MarcaLogo,
    "Bet365": Bet365Logo,
    "Paston": PastonLogo,
    "Bwin": BwinLogo,
    "WilliamHill": WilliamHillLogo,
    "Codere": CodereLogo,
    "Luckia": LuckiaLogo,
    "Sportium": SportiumLogo,
    "Betfair": BetfairLogo,
    "Onexbet": OnexbetLogo,
    "LeoVegas": LeoVegasLogo,
    "Botemania": BotemaniaLogo,
    "Apuestas": ApuestasLogo
};
{/* TODO - TRANSFORM INTO COMPONENT*/ }

const Logo = props => {
    let TagName = NoLogo;

    const logoName = props.name.replace(/\s/g, '');    

    if (typeof validLogos[logoName] !== "undefined") {
        TagName = validLogos[logoName];
    }

    return (
        <TagName className="logo-opiniones {}" name={props.name} classsSuffix={props.classsSuffix}/>
    );
};

const OpinionsCard = props => {
    return (
        <div className="object-card opinion-widget__margin">
            <div className="opiniones-widget-container">

                <div className="numb-opiniones text-center">
                    {'#' + props.rank}
                </ div>

                <div className="name-opiniones bet-site-name text-center">
                    <Logo className="logo-opiniones" name={props.name} classsSuffix={""}/>
                </ div>

                <div className="rating-opiniones bet-site-name">
                    <div className="rating-opiniones__numb">
                        <div className="rating-opiniones__numb__svg">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                                <path d="M0 0h24v24H0V0z" fill="none" />
                                <path d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 
                                15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"/>
                            </svg>
                        </ div>
                        <div className="rating-opiniones__numb__val">
                            {props.rating} 
                        </ div>
                    </ div>
                    <div className="bonus-opiniones__label bonus-opiniones__label_val text-center">
                        <a href={props.reviewUrl}>
                            <div className="review-opiniones__label">
                                <div className="review-opiniones__label__text"> Leer Opinión </ div>
                            </ div>
                        </ a>
                    </ div>
                </ div>

                <div className="description-opiniones">
                    {props.shortText}
                </ div>

                <div className="bonus-eu-opiniones bet-site-name text-center dashed-red-border no-padding">
                    <div className="bonus-eu-opiniones__bono">
                        {props.bonoEuros}€
                    </ div>
                    <div className="bonus-recomm__label">
                        bono del 100% hasta
                    </ div>
                </ div>

                <div className="play-opiniones text-center">
                    <div className="opiones-btn">
                        <a href={props.bonoUrl} target="blank" className="md-btn text-center">
                            Jugar Ahora
                        </ a>
                    </ div>
                </ div>
            </ div>
        </ div>
    )
};

const OpinionesWidget = (props) => {
    let endPoint = BettingSites.length;
    let startPoint = 0;

    if (props.endPoint !== undefined &&
        props.endPoint !== null &&
        props.endPoint <= BettingSites.length) {
        endPoint = props.endPoint;
    }

    if (props.startPoint !== undefined &&
        props.startPoint !== null &&
        props.startPoint >= 0) {
        startPoint = props.startPoint;
    }

    const [opiniones, setOpiniones] = useState(BettingSites.slice(startPoint, endPoint));

    return (
        <div className="game">
            <div className="opiniones-container">
                {opiniones.map(b => (
                    <OpinionsCard
                        key={b.id}
                        rank={b.rank}
                        name={b.name}
                        bonoEuros={props.type == "casinos" ? b.bonoCasino : b.bonoEuros}
                        reviewUrl={b.reviewUrl}
                        bonoUrl={props.type == "casinos" ? b.bonoUrlCasino : b.bonoUrl }
                        rating={b.rating}
                        shortText={b.shortText }
                    />
                ))}
            </div>
        </div>
    );
};

export default OpinionesWidget;